import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from "src/app/shared/http.service";
import { APIEndpoints } from "src/config/apiEndpoint.config";
import { SettingDto } from "../models/SettingDto";

@Injectable()
export class GeneralSettingsService {
  constructor(private readonly httpService: HttpService) {}

  getGeneralSettings(): Observable<SettingDto[]> {
    return this.httpService.get(APIEndpoints.getGeneralSettings);
  }

  changeGeneralSetting(data: SettingDto) {
    return this.httpService.post(
      APIEndpoints.changeGeneralSetting,
      data,
      false
    );
  }
}
